import styled from 'styled-components'

export const Container = styled.div`
  align-items: center;
  cursor: grab;
  display: flex;
  user-select: none;
  position: relative;

  &:active {
    cursor: grabbing;
  }

  & > .container {
    overflow: hidden;
    width: 100%;

    & > .cards {
      align-items: stretch;
      display: flex;
      gap: 24px;
      transition: transform 0.2s ease-out;
      width: 100%;

      & > * {
        height: 100%;
        width: 100%;
      }

      &.click-blocked {
        pointer-events: none;
      }
    }
  }

  & > .arrow {
    align-items: center;
    background-color: #084F43;
    border: none;
    border-radius: 50%;
    bottom: 50%;
    cursor: pointer;
    display: flex;
    height: 40px;
    justify-content: center;
    margin: auto 0;
    position: absolute;
    top: 50%;
    width: 40px;

    & > img {
      height: 24px;
      width: 24px;
    }

    &.previous {
      left: -20px;
    }

    &.next {
      right: -20px;
      transform: rotate(180deg);
    }
  }

  @media (max-width: 568px) {
    & > .container {
      & > .cards {
        gap: 16px;
      }
    }
  }
`

export const FadeOverlay = styled.div`
  background: linear-gradient(270deg, #FCF8EF 0%, #fcf8EF00 20%);
  position: absolute;
  inset: 0;
  pointer-events: none;
`
